/*
 * Тексты лендинга по новому ТЗ.
 *
 * Всё, что взято из брифа, приведено дословно. Места, где бриф текста не даёт,
 * помечены комментарием: их нужно согласовать, а не считать утверждёнными.
 *
 * Важное отличие от прежнего ТЗ: география запрещена. Ни Абхазии, ни городов,
 * ни гор — ни в текстах, ни в макетах экранов. Прежний заголовок «Абхазия в
 * одном приложении» этому ТЗ противоречит и здесь не используется.
 */

/**
 * Шапка одна на все варианты: знак слева, разделы по центру, вход справа.
 * Выбора языка здесь нет — готов один язык, и список из одного пункта
 * места занимает больше, чем даёт.
 */
export const HEADER = {
  nav: [
    { id: 'product', label: 'Возможности' },
    { id: 'advantage', label: 'Преимущества' },
    { id: 'install', label: 'Установка' },
    { id: 'contacts', label: 'Контакты' },
  ],
};

/** Общее для всех hero. Строка платформ — muted information, не три кнопки. */
export const CTA = {
  install: 'Установить AURA',
  platforms: ['iPhone', 'Android', 'Web'],
};

export const HEROES = {
  '01': {
    id: '01',
    name: 'Typographic / Editorial',
    wordmark: 'AURA.',
    title: 'Всё вокруг вас.',
    lead: 'Одно пространство, которое объединяет людей, связи и всё, что становится частью вашей жизни.',
    marquee: 'ЛЮДИ · МЕСТА · СВЯЗИ · МОМЕНТЫ',
  },
  '02': {
    id: '02',
    name: 'AURA Space',
    wordmark: 'AURA.',
    title: 'Начинается с вас.',
    lead: 'Пространство, которое складывается вокруг человека, его связей и жизни.',
    marquee: 'ОДИН ЧЕЛОВЕК · ОДНА AURA · ОДНО ПРОСТРАНСТВО',
  },
  '03': {
    id: '03',
    name: 'Giant word / Object collision',
    wordmark: 'AURA.',
    title: 'Ваш мир. Рядом.',
    lead: 'Всё, что имеет значение вокруг вас, соединяется в одном пространстве.',
    // Бриф для 03 маркиз не задаёт, но требует «тонкой полосой у нижнего края».
    // Берём строку из 01: она про содержание пространства, а не про вариант.
    marquee: 'ЛЮДИ · МЕСТА · СВЯЗИ · МОМЕНТЫ',
  },
  '04': {
    id: '04',
    name: 'Minimal / Ripple',
    wordmark: 'AURA.',
    title: 'Ваша. Живая. Настоящая.',
    lead: 'Один мир вместо многих.',
    marquee: 'ОДИН ЧЕЛОВЕК · ОДНА AURA · ОДНО ПРОСТРАНСТВО',
  },
  '05': {
    id: '05',
    name: 'Степень',
    // Развитие третьего варианта: тот же приём столкновения слова и формы,
    // но утверждение вынесено в верхний индекс — читается как степень при
    // AURA. Поясняющий текст уходит под заголовок, а не в сторону.
    wordmark: 'AURA',
    title: 'Ваш мир. Рядом.',
    lead: 'Всё, что имеет значение вокруг вас, соединяется в одном пространстве.',
    marquee: 'ЛЮДИ · МЕСТА · СВЯЗИ · МОМЕНТЫ',
  },
  '06': {
    id: '06',
    name: 'Ландшафт',
    wordmark: 'AURA.',
    title: 'Ваш мир. Рядом.',
    lead: 'Всё, что имеет значение вокруг вас, соединяется в одном пространстве.',
    marquee: 'ЛЮДИ • СВЯЗИ • ДОВЕРИЕ • ВОЗМОЖНОСТИ',
  },
};

/*
 * Сценарии. Только те, что действительно существуют: Лента, Маркет,
 * Мессенджер, Люди, Профиль. Фурт, Карта и Трансляции сюда не попадают —
 * бриф прямо запрещает показывать их как полноценные сценарии, пока их нет.
 *
 * При смене сценария меняется не только экран телефона, но и заголовок,
 * описание и сопровождающий объект — это главное правило блока.
 */
export const SCENARIOS = [
  {
    id: 'feed',
    name: 'Лента',
    screen: 'feed',
    title: 'Будьте в курсе того, чем живут люди вокруг.',
    text: 'Фото, истории и контент тех, кто вам действительно интересен.',
    // Вариант 02 даёт для Ленты другую пару — она про действие, а не про
    // наблюдение, и подходит именно карусельной подаче.
    altTitle: 'Делитесь тем, что происходит.',
    altText: 'Публикуйте фото и оставайтесь рядом с теми, кто вам интересен.',
    breakout: 'photo',
  },
  {
    id: 'people',
    name: 'Люди',
    screen: 'people',
    // ТЗ пары для «Людей» не даёт — написано в тон соседних, требует
    // согласования.
    title: 'Рядом больше знакомых, чем кажется.',
    text: 'Люди вокруг, общие интересы и новые связи — в одном месте.',
    breakout: 'profile',
    pending: true,
  },
  {
    id: 'shop',
    name: 'Маркет',
    screen: 'shop',
    title: 'Найдите нужное. Или того, кто это сделает.',
    text: 'Товары и услуги живут рядом — без перехода между разными сервисами.',
    breakout: 'product',
  },
  {
    id: 'chat',
    name: 'Мессенджер',
    screen: 'chat',
    title: 'Разговор начинается здесь.',
    text: 'Личные сообщения, звонки и каналы — внутри пространства, где уже есть ваши люди.',
    breakout: 'voice',
  },
  {
    id: 'profile',
    name: 'Профиль',
    screen: 'profile',
    // Тоже написано нами: в брифе пары для «Профиля» нет.
    title: 'Одно имя во всех сценариях.',
    text: 'Профиль, репутация и история остаются с вами везде внутри AURA.',
    breakout: 'profile',
    pending: true,
  },
];

export const PRODUCT = {
  '01': {
    id: '01',
    name: 'Cinematic stage',
    title: 'Всё нужное — в одном пространстве.',
  },
  '02': { id: '02', name: 'Glass carousel', title: 'AURA под разные моменты жизни.' },
  '03': { id: '03', name: 'UI breakout', title: 'Один AURA. Разные сценарии.' },
  '04': { id: '04', name: 'Editorial split', title: 'Всё, что нужно сейчас.' },
};

/** Четыре неизменных смысла блока доверия. Меняется подача, не содержание. */
export const TRUST_POINTS = [
  {
    n: '01',
    title: 'Настоящий человек',
    text: 'Личность подтверждена.',
    layer: 'IDENTITY',
  },
  {
    n: '02',
    title: 'Единая репутация',
    text: 'История остаётся с вами.',
    layer: 'REPUTATION',
  },
  {
    n: '03',
    title: 'Ваши границы',
    text: 'Вы решаете, что показывать.',
    layer: 'PRIVACY',
  },
  {
    n: '04',
    title: 'Защищённые действия',
    text: 'Доверие встроено в продукт.',
    layer: 'PROTECTION',
  },
];

export const TRUST = {
  '01': {
    id: '01',
    name: 'Identity core',
    title: 'Доверие встроено в AURA.',
    lead: 'Не отдельная функция, а часть пространства, в котором люди взаимодействуют друг с другом.',
  },
  '02': {
    id: '02',
    name: 'Four layers',
    title: 'Доверие начинается с устройства системы.',
    lead: 'Личность. Репутация. Границы. Защита. Всё работает вместе.',
  },
  '03': {
    id: '03',
    name: 'Trust network',
    title: 'Проще доверять, когда всё связано.',
    lead: 'За каждым действием остаются человек, история и репутация.',
  },
  '04': {
    id: '04',
    name: 'Typographic trust',
    // Слова сменяются по мере прокрутки, финальное — AURA.
    words: ['НАСТОЯЩИЙ', 'ВАШ', 'ЗАЩИЩЁННЫЙ', 'AURA.'],
    lines: [
      'Настоящий человек — личность подтверждена.',
      'Ваша история — репутация остаётся с вами.',
      'Ваши границы — вы решаете, что показывать.',
      'Ваши действия — защищены системой.',
    ],
  },
};

/*
 * Блок 4. Отвечает на вопрос «почему модель AURA лучше набора отдельных
 * приложений», а не перечисляет сценарии заново.
 *
 * Четыре варианта текста из брифа. A — основной, D помечен в брифе как
 * дополнительный: он ближе к Product и Trust.
 */
export const ADVANTAGE_COPY = {
  a: {
    id: 'a',
    label: 'A · основной',
    title: 'Не вы подстраиваетесь под сервис. Он подстраивается под вас.',
    // Второе состояние заголовка для «жидкой архитектуры»: текст
    // договаривается вместе с перестроением формы.
    titleStart: 'Не вы подстраиваетесь под сервис.',
    titleEnd: 'Он — под вас.',
    lead: 'AURA собирается вокруг человека — его связей, интересов и того, что ему нужно сейчас.',
  },
  b: {
    id: 'b',
    label: 'B · брендовый',
    title: 'Одна система. Но никогда не одна и та же AURA.',
    titleStart: 'Одна система.',
    titleEnd: 'Но никогда не одна и та же AURA.',
    lead: 'Пространство меняется вместе с вами — сохраняя ваши связи, историю и возможности внутри одной системы.',
  },
  c: {
    id: 'c',
    label: 'C · манифест',
    title: 'AURA принимает вашу форму.',
    titleStart: 'AURA',
    titleEnd: 'принимает вашу форму.',
    lead: 'Не набор отдельных сервисов, а пространство, которое складывается вокруг вас.',
  },
  d: {
    id: 'd',
    label: 'D · дополнительный',
    title: 'Один человек. Одна AURA. Множество возможностей.',
    titleStart: 'Один человек. Одна AURA.',
    titleEnd: 'Множество возможностей.',
    lead: 'Вместо разных профилей и разрозненных сервисов — одно пространство, которое развивается вместе с вами.',
  },
};

export const ADVANTAGE = {
  a: { id: 'a', name: 'Жидкая архитектура' },
  b: { id: 'b', name: 'Одна AURA, разные состояния' },
  c: { id: 'c', name: 'Пространство следует за вами' },
  d: { id: 'd', name: 'Из многих — одно' },
};

/** Финал варианта 4D. Приходит только после того, как фрагменты собрались. */
export const ADVANTAGE_D_FINAL = {
  title: 'Один человек. Одна AURA.',
  text: 'Всё, что раньше существовало отдельно, становится частью одного пространства.',
};

/* ── Страница установки на Android ──────────────────────────────── */

export const RELEASE = {
  version: '1.0.8',
  size: '159,0 МБ',
  date: '17 октября 2026',
  apk: 'https://aura-vibe.site/aura.apk',
};

export const ANDROID = {
  title: 'Установить AURA на Android',
  lead: 'Четыре шага, около двух минут.',
  cta: 'Скачать APK',
  // Страница не продаёт приложение заново: человек уже решил ставить.
  // Её задача — снять тревогу и провести до открытия приложения.
  reassurance: 'Официальный файл с сайта AURA. Установка занимает пару минут.',
  steps: [
    {
      n: '01',
      title: 'Скачайте файл',
      text: 'Браузер предупредит, что файлы такого типа могут навредить устройству. Это обычное предупреждение Android для всего, что не из магазина. Нажмите «Всё равно скачать».',
      screen: 'sysDownload',
      highlightLabel: 'Всё равно скачать',
    },
    {
      n: '02',
      title: 'Разрешите установку',
      text: 'Откройте скачанный файл. Телефон скажет, что установка заблокирована, и предложит перейти в настройки — нажмите и включите переключатель.',
      screen: 'sysAllow',
      path: 'Настройки → Установка неизвестных приложений → Разрешить',
      highlightLabel: 'Разрешить',
    },
    {
      n: '03',
      title: 'Установите',
      text: 'Вернитесь к файлу и нажмите «Установить». Дождитесь окончания — это несколько секунд.',
      screen: 'sysInstall',
      highlightLabel: 'Установить',
    },
    {
      n: '04',
      title: 'Откройте AURA',
      text: 'Нажмите «Открыть» или найдите значок AURA на главном экране.',
      screen: 'home',
      highlightLabel: 'Открыть',
    },
  ],
  troubleTitle: 'Не получается установить?',
  trouble: [
    {
      q: 'Не вижу скачанный файл',
      a: `Откройте шторку уведомлений и нажмите на завершённую загрузку. Либо найдите файл в приложении «Файлы» или «Загрузки» — он называется aura-${RELEASE.version}.apk.`,
    },
    {
      q: 'Android блокирует установку',
      a: 'В системном окне нажмите «Настройки» — телефон сам откроет нужный переключатель для того браузера, из которого вы скачали файл. Искать его вручную в меню не нужно.',
    },
    {
      q: 'Появилось предупреждение Play Protect',
      // Формулировку надо сверить с реальным поведением Android на тестовых
      // устройствах — бриф прямо это оговаривает.
      a: 'Play Protect проверяет приложения не из Google Play. Выберите «Установить всё равно» или «Подробнее → Установить». Проверка ничего не удаляет с телефона.',
      verify: true,
    },
    {
      q: 'У меня другая версия Android',
      a: 'Названия пунктов могут немного отличаться в зависимости от устройства и оболочки. Смысл тот же: разрешить установку из того приложения, откуда вы скачали файл.',
    },
  ],
  support: { label: 'Написать в поддержку', href: 'https://t.me/aura_vibe_app' },
  update: {
    title: 'А как обновлять AURA?',
    text: 'Скачайте новую версию и установите её поверх текущей. Удалять приложение перед обновлением не нужно.',
  },
};

export const CONTACTS = {
  title: 'Контакты',
  support: [
    { label: 'support@aura-vibe.site', href: 'mailto:support@aura-vibe.site' },
    { label: 'Telegram', href: 'https://t.me/aura_vibe_app' },
  ],
  legal: [
    { label: 'Политика конфиденциальности', href: '/privacy_policy' },
    { label: 'Пользовательское соглашение', href: '/user_agreement' },
    { label: 'Обработка cookie', href: '/cookie_policy' },
    { label: 'Согласие на обработку данных', href: '/personal_data' },
  ],
};

/*
 * Модальное окно установки. Сделано 1-в-1 по прототипу.
 *
 * Три способа — не больше: выбор не перегружаем. Определение устройства
 * поднимает подходящий способ наверх, но ничего не прячет. QR — дополнение
 * и только на desktop и планшете: с телефона он бесполезен.
 */
export const MODAL = {
  title: 'Открыть AURA',
  lead: 'Выберите удобный способ',
  methods: [
    {
      id: 'web',
      icon: 'globe',
      name: 'В браузере',
      text: 'Без установки. Работает сразу в любом браузере.',
      action: 'Открыть AURA',
      href: '/app/feed',
    },
    {
      id: 'ios',
      icon: 'apple',
      name: 'iPhone и iPad',
      text: 'Установка и обновления через App Store.',
      action: 'Открыть App Store',
      href: 'https://apps.apple.com/ru/app/aura-vibe/id6737061162',
    },
    {
      id: 'android',
      icon: 'android',
      name: 'Android',
      text: 'Официальное приложение AURA для Android.',
      action: 'Скачать APK',
      href: RELEASE.apk,
      link: { label: 'Как установить на Android', href: '/android' },
    },
  ],
  qr: {
    title: 'Открыть на телефоне',
    text: 'Отсканируйте QR-код, чтобы открыть страницу установки на телефоне.',
    // Корень сайта, а не отдельная страница установки: её в этой версии
    // нет, а на лендинге человека встречает то же окно с тремя способами.
    url: 'https://aura-vibe.site/',
  },
  assurances: [
    {
      icon: 'shield',
      title: 'Безопасно',
      text: 'Официальные источники и проверенные файлы',
    },
    {
      icon: 'refresh',
      title: 'Всегда актуально',
      text: 'Получайте новые функции и улучшения',
    },
    {
      icon: 'lock',
      title: 'Ваши данные защищены',
      text: 'Конфиденциальность на первом месте',
    },
  ],
};

/*
 * Блок 5 — «Установка». Идёт перед FAQ.
 *
 * У него другая задача, чем у предыдущих: не рассказать что-то новое, а
 * завершить историю и дать действие. Hero говорит «всё начинается вокруг
 * вас», Product — что пространство умеет, Trust — почему ему можно доверять,
 * блок 4 — что AURA меняется под человека. Пятый говорит: теперь это
 * пространство ваше.
 *
 * Поэтому здесь нет ни новых возможностей, ни сценариев: только утверждение,
 * кнопка и короткая опора под ней.
 */
export const CTA_BLOCK = {
  cta: 'Установить AURA',
  platforms: ['iPhone', 'Android', 'Web'],

  '01': {
    id: '01',
    name: 'Кристалл',
    titleTop: 'ВАША AURA',
    titleBottom: 'НАЧИНАЕТСЯ ЗДЕСЬ.',
    accentWord: 'AURA',
    lead: 'Одно пространство для того, что важно именно вам.',
    footnotes: [
      { icon: 'space', label: 'Одно пространство' },
      { icon: 'star', label: 'Всё, что важно' },
      { icon: 'people', label: 'Ваши связи' },
      { icon: 'shield', label: 'Под защитой' },
    ],
  },

  '02': {
    id: '02',
    name: 'Метрики',
    titleTop: 'ТЕПЕРЬ —',
    titleBottom: 'ВАША.',
    accentWord: 'ВАША.',
    lead: 'Пространство AURA меняется под вас. Оставаясь вашим.',
    // Не аудитория и не отзывы: это свойства модели, а не выдуманная
    // статистика. Цифры, которых нельзя подтвердить, сюда не попадают.
    metrics: [
      { value: '1', label: 'пространство' },
      { value: '∞', label: 'возможностей' },
      { value: '100%', label: 'ваш выбор' },
      { value: '0', label: 'потери данных' },
    ],
  },

  '03': {
    id: '03',
    name: 'Слова и луч',
    // Призрачные слова на фоне — то, из чего складывается пространство.
    // Поверх них остаётся одно чёрное: AURA.
    ghost: ['ЛЮДИ', 'СВЯЗИ', 'МОМЕНТЫ', 'ДОВЕРИЕ', 'ВОЗМОЖНОСТИ'],
    titleBottom: 'AURA.',
    lead: 'Один мир вместо многих.',
  },

  '04': {
    id: '04',
    name: 'Сборка',
    titleTop: 'СОЗДАЙТЕ',
    titleBottom: 'СВОЮ AURA.',
    accentWord: 'AURA.',
    lead: 'Выбирайте то, что важно. AURA подстроится под вас.',
    orbit: [
      { icon: 'people', label: 'Люди' },
      { icon: 'chat', label: 'Общение' },
      { icon: 'star', label: 'Возможности' },
      { icon: 'heart', label: 'Интересы' },
    ],
    footnotes: [
      { icon: 'wave', label: 'Адаптируется под вас' },
      { icon: 'space', label: 'Всегда с вами' },
      { icon: 'grid', label: 'Всё в одном' },
      { icon: 'shield', label: 'Безопасно' },
    ],
  },

  '05': {
    id: '05',
    name: 'Портал',
    titleTop: 'ВХОДИТЕ',
    titleBottom: 'В AURA.',
    accentWord: 'AURA.',
    lead: 'Ваше пространство уже ждёт вас внутри.',
    pillars: [
      {
        icon: 'star',
        title: 'Ваше пространство',
        text: 'Подстраивается под вас',
      },
      { icon: 'people', title: 'Ваши связи', text: 'Всегда с вами' },
      { icon: 'shield', title: 'Ваши данные', text: 'Под защитой' },
    ],
  },

  '06': {
    id: '06',
    name: 'Ритм',
    titleTop: 'ОДНА AURA.',
    titleBottom: 'ВАШ РИТМ.',
    accentWord: 'AURA.',
    lead: 'Пространство, которое меняется вместе с вашей жизнью.',
    footnotes: [
      { icon: 'wave', label: 'Живая система' },
      { icon: 'space', label: 'Под ваш ритм' },
      { icon: 'star', label: 'Без лишнего' },
      { icon: 'refresh', label: 'Всегда актуальна' },
    ],
  },
};

/*
 * FAQ. Вопросы одни и те же во всех шести подачах — меняется только
 * композиция.
 *
 * Ответ на первый вопрос взят из макета дословно. Остальные написаны нами
 * по известным фактам и помечены: их нужно согласовать, прежде чем
 * показывать наружу. Особенно последний — про данные.
 */
export const FAQ_BLOCK = {
  eyebrowShort: 'FAQ',
  titles: {
    '01': { title: 'FAQ', lead: 'Ответы на главные вопросы.' },
    '02': { title: 'ОСТАЛИСЬ ВОПРОСЫ?', lead: 'Мы собрали главное.' },
    '03': { title: '', lead: '' },
    '04': { title: 'ВОПРОСЫ И ОТВЕТЫ', lead: 'Важное — коротко и по делу.' },
    '05': {
      title: 'Есть вопрос? Мы на связи.',
      lead: 'Ответы на то, что чаще всего интересует пользователей.',
    },
    '06': { title: 'FAQ', lead: 'Мы собрали ответы на самые важные вопросы.' },
  },
  items: [
    {
      n: '01',
      icon: 'chat',
      q: 'AURA бесплатная?',
      a: 'Да. Скачать приложение, создать аккаунт и пользоваться основными возможностями AURA можно бесплатно.',
    },
    {
      n: '02',
      icon: 'globe',
      q: 'Где работает AURA?',
      a: 'На iPhone, Android и в браузере. Аккаунт один — войти можно с любого устройства.',
      pending: true,
    },
    {
      n: '03',
      icon: 'refresh',
      q: 'Почему AURA пока нет в Google Play?',
      a: 'Приложение проходит проверку. Пока его можно установить напрямую с нашего сайта или открыть в браузере.',
    },
    {
      n: '04',
      icon: 'shield',
      q: 'Безопасно ли устанавливать AURA на Android с сайта?',
      a: 'Да, если скачивать только с aura-vibe.site. Мы публикуем версию, размер и дату обновления — сверьте их перед установкой.',
    },
    {
      n: '05',
      icon: 'lock',
      q: 'Что AURA делает с моими данными?',
      // Формулировку обязательно согласовать с юристами и с политикой
      // конфиденциальности: это самый чувствительный ответ на странице.
      a: 'Данные нужны, чтобы приложение работало: профиль, переписки и настройки видимости. Вы сами решаете, что показывать другим. Подробности — в политике конфиденциальности.',
      pending: true,
    },
  ],
  fallback: {
    n: '06',
    q: 'Не нашли ответ?',
    action: 'Написать в поддержку',
    href: 'https://t.me/aura_vibe_app',
  },
};

/*
 * Футер. Реквизиты обязательны по закону и потому остаются, несмотря на
 * общий запрет географии: адрес юридического лица — не визуальный мотив,
 * а требование к раскрытию информации.
 */
export const FOOTER_BLOCK = {
  wordmark: 'aura',
  tagline: 'Пространство вокруг вас.',
  channels: [
    {
      id: 'tg',
      icon: 'send',
      title: 'Telegram-канал',
      note: 'Новости и обновления',
      handle: 't.me/aura_vibe',
      href: 'https://t.me/aura_vibe_app',
    },
    {
      id: 'support',
      icon: 'support',
      title: 'Поддержка',
      note: 'Мы рядом',
      handle: 'support@aura-vibe.site',
      href: 'mailto:support@aura-vibe.site',
    },
  ],
  legal: [
    { label: 'Конфиденциальность', href: '/privacy_policy' },
    { label: 'Обработка данных', href: '/cookie_policy' },
    { label: 'Пользовательское соглашение', href: '/user_agreement' },
    { label: 'Согласие на обработку ПД', href: '/personal_data' },
  ],
  requisites: [
    'ООО «Falcon»',
    'Республика Абхазия, г. Сухум, проспект Мира, 16',
    'ОГРН 108РА000782',
    'ИНН 11008213',
  ],
  meta: ['© 2026 AURA', 'RU', '18+'],
};
